<template>
  <v-container fluid class="grey lighten-2">
    <v-row>
      <v-col class="mt-2" cols="12">
        <v-dialog v-model="dialog" max-width="800" scrollable persistent transition="dialog-bottom-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on">
              <v-icon id="house">{{ icon }}</v-icon>{{ phrase.title_house }}
            </v-btn>
          </template>

          <v-card height=400>
            <v-card-title class="text-h5 grey lighten-2">{{ phrase.title_house }}</v-card-title>
            <v-card-text style="white-space: pre-line">
              <div class="my-5 text--primary">{{ help_house_text }}</div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-start">
              <v-btn color="primary" text @click="dialog = false">
                {{ phrase.dialog_close }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-select class="d-inline-flex align-center mt-2 ml-4" :items="filteredHouses" item-text="select" return-object :label="this.$store.state.select.house" @change="value_house"></v-select>
        <span class="ml-4 font-weight-bold header-total-inline">合計 {{ (this.$store.state.breakdown.house).toLocaleString() }}円</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-row>
          <v-col class="mt-2 d-flex" cols="12" sm="6" md="4" lg="4" v-for="house in filteredHouses" :key="house.key">
            <v-card class="d-flex flex-column flex-grow-1">
              <v-card-title>{{ house.select }}</v-card-title>
              <v-col align="center">
                <v-img max-height="200" max-width="200" v-bind:src="require('@/assets/house/'+house.img+'.jpg')"></v-img>
              </v-col>
              <v-card-text>
                <v-simple-table>
                  <thead></thead>
                  <tbody>
                    <tr>
                      <td>間取り</td>
                      <td>{{ house.layout }}</td>
                    </tr>
                    <tr>
                      <td>タイプ</td>
                      <td>{{ house.type }}</td>
                    </tr>
                    <tr>
                      <td>立地</td>
                      <td>{{ house.location }}</td>
                    </tr>
                    <tr>
                      <td>階数</td>
                      <td>{{ house.floors }}階</td>
                    </tr>
                    <tr>
                      <td>築年数</td>
                      <td>{{ house.age }}年</td>
                    </tr>
                    <tr>
                      <td>広さ</td>
                      <td>{{ house.square }}平米</td>
                    </tr>
                    <tr>
                      <td>駅徒歩</td>
                      <td>{{ house.walk }}分</td>
                    </tr>
                    <tr>
                      <td>購入価格</td>
                      <td>{{ house.purchase.toLocaleString() }}万円</td>
                    </tr>
                    <tr>
                      <td>住宅ローン</td>
                      <td>{{ house.loan }}</td>
                    </tr>
                    <tr>
                      <td>月々支払い</td>
                      <td>{{ house.rent.toLocaleString() }}円</td>
                    </tr>
                    <tr>
                      <td>備考</td>
                      <td>{{ house.note }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import words from '../assets/words.json'

export default({
  data: () => ({
    icon: 'mdi-home',
    dialog: false,
    phrase: {}
  }),
  mounted: function () {
    this.getWords()
  },
  computed: {
    filteredHouses () {
      const houses = this.$store.state.login_response.house || []
      const people = Number((this.$store.state.login_response.persona || {}).people)

      if (people === 1) {
        return houses.filter(h => h.target_household === 'single')
      }

      return houses.filter(h => h.target_household === 'all')
    },
    help_house_text () {
      return this.phrase.help_house
    }
  },
  methods: {
    value_house: function(value) {
      console.log('value', value);
      this.$store.commit('value_house', value);
      this.$store.commit('value_electricity', value.rent);
      this.$store.commit('rebalance');
      this.$store.commit('set_progress');
    },
    getWords: function () {
      this.phrase = words
    }
  }
})
</script>
